import { gql } from '@apollo/client';
export const MANAGEMENT_CLASSROOM_GRADES_TABLE_GRADE_FIELDS = gql`
  fragment ManagementClassroomGradesTableGrade on ManagementClassroomGradesTableGradeDto {
    courseId
    code
    grade
  }
`;
export const MANAGEMENT_CLASSROOM_GRADES_TABLE_ROW_FIELDS = gql`
  ${MANAGEMENT_CLASSROOM_GRADES_TABLE_GRADE_FIELDS}
  fragment ManagementClassroomGradesTableRow on ManagementClassroomGradesTableRowDto {
    studentId
    studentName
    studentAssessmentToolGrades {
      ...ManagementClassroomGradesTableGrade
    }
  }
`;
export const MANAGEMENT_CLASSROOM_GRADES_TABLES_FIELDS = gql`
  ${MANAGEMENT_CLASSROOM_GRADES_TABLE_ROW_FIELDS}
  fragment ManagementClassroomGradesTable on ManagementClassroomGradesTableDto {
    id
    name
    rows {
      ...ManagementClassroomGradesTableRow
    }
  }
`;